class MaterialGalleryComponent {

  private elScope: HTMLElement;

  private el: {
    btLoadMore: HTMLElement | null,
    btLoadLess: HTMLElement | null,
  };

  private className = {
    displayAll: 'display-all',
  };

  constructor(elScope: HTMLElement) {
    this.elScope = elScope;
    this.init();
  }

  private init(): void {
    this.cache();
    this.bindings();
  }

  private cache(): void {
    this.el = {
      btLoadMore: this.elScope.querySelector('.js-o-material-gallery__bt-all'),
      btLoadLess: this.elScope.querySelector('.js-o-material-gallery__bt-less'),
    };
  }

  private bindings(): void {
    const { el } = this;

    el.btLoadMore?.addEventListener('click', () => this.toggle({scrollBack: false}));
    el.btLoadLess?.addEventListener('click', () => this.toggle({scrollBack: true}));
  }

  private toggle({scrollBack = false}: {scrollBack: boolean}): void {
    const { elScope, className } = this;

    elScope.classList.toggle(className.displayAll);

    if (scrollBack) {
      setTimeout(() => {
        window.scrollTo(0, (this.elScope?.getBoundingClientRect().top || 0) - 80 + window.scrollY);
      }, 50);
    }
  }
}


export default class MaterialGallery {

  init() {
    document.querySelectorAll('.js-material-gallery').forEach((el) => {
      new MaterialGalleryComponent(el as HTMLElement);
    });
  }
}
